import moment from "moment"

function reducer(state = {}, action) {
  switch (action.type) {
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/reducer.js